exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mb10[data-v-24daf47a]{margin-bottom:10px}", ""]);

// exports
